// extracted by mini-css-extract-plugin
export var container = "_bx-1";
export var cornerButtonContainer = "_bx-6";
export var disabled = "_bx-2";
export var dragActive = "_bx-3";
export var fileContainer = "_bx-5";
export var hiddenInput = "_bx-4";
export var widthContainer = "_bx-0";